// src/pages/AboutPage.jsx
import Footer from "../footer";
import { Helmet } from "react-helmet";
import TeamSection1 from "./subpages/team/team1";
function TeamPage() {
  return (
    <div className="container-fluid px-0">
      <Helmet>
        <title>Equipo Voila</title>
        <meta name="description" content="Description of your page for SEO" />
      </Helmet>
      <TeamSection1 />
      <Footer isScrollable={false} />
    </div>
  );
}

export default TeamPage;
